import { render } from "./NumberCard.vue?vue&type=template&id=4aba5d4a&scoped=true"
import script from "./NumberCard.vue?vue&type=script&lang=js"
export * from "./NumberCard.vue?vue&type=script&lang=js"

import "./NumberCard.vue?vue&type=style&index=0&id=4aba5d4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4aba5d4a"

export default script